import { useNavigate, useSearch } from "@tanstack/react-router";
import { useCallback } from "react";
import { ALL_CONTRACT_TYPES } from "@/components/profitability/ContractTypeSelect";

/**
 * Reads and writes ?contract_type=, alongside ?range=.
 *
 * In the URL for the same reason the range is: the account list and the account
 * page must agree on which contracts they are counting, and a pasted link has
 * to reproduce what the sender saw.
 */
export function useContractTypeParam(): [string, (key: string) => void] {
  const search = useSearch({ strict: false }) as { contract_type?: string };
  const navigate = useNavigate();
  const value = search.contract_type ?? ALL_CONTRACT_TYPES;

  // Stable identity, for the reason useRangeParam's setter is: the header
  // publishes it, and a fresh closure each render loops usePageHeader.
  const setValue = useCallback(
    (key: string) => {
      navigate({
        to: ".",
        replace: true,
        search: (prev) => ({
          ...prev,
          // "all" is the default, so it stays out of the URL entirely.
          contract_type: key === ALL_CONTRACT_TYPES ? undefined : key,
        }),
      });
    },
    [navigate],
  );

  return [value, setValue];
}
